import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Button from '../../../../UniformComponents/Button'
import Select from '../../../form/Select'
import Panel from '../../../../UniformComponents/Panel'
import PanelHeader from '../../../../UniformComponents/PanelHeader'
import InfoAccordion from '../../../InfoAccordion'
import Badge from '../../../../UniformComponents/Badge'

import QuestionOption from './QuestionOption'
import Applied from './Applied'

import Rule from '../../../ReportV2/components/Modal/Filter/model/Rule'
import RuleLogic from '../../../ReportV2/components/Modal/Filter/model/RuleLogic'
import RuleGroup from '../../../ReportV2/components/Modal/Filter/model/RuleGroup'

@observer
class FilterPanel extends Component {
    constructor(props) {
        super(props)

        const { ruleGroup, filterKey } = props

        this.state = {
            showBody: false,
            ruleGroup: RuleGroup.clone(ruleGroup[filterKey]),
        }
    }

    save = () => {
        const { filterKey, onSave } = this.props
        onSave(filterKey, RuleGroup.clone(this.state.ruleGroup))
    }

    discard = () => {
        const { ruleGroup } = this.state
        ruleGroup.discard()
    }

    addRule = (label, id, rule, questionTypeCode) => {
        const { store } = this.props
        const { ruleGroup } = this.state

        store.addFilterRule(ruleGroup, label, id, rule, questionTypeCode)
    }

    renderQuestionOptions = (options) => {
        const { store, filterKey } = this.props
        const { ruleGroup } = this.state
        return options?.map((option, i) => (
            <QuestionOption
                key={option.id ?? i}
                ruleGroup={ruleGroup}
                option={option}
                index={i}
                addRuleOption={this.addRule}
                store={store}
                filterKey={filterKey}
            />
        ))
    }

    renderLogic = (logicRule) => (
        <Select
            label="Function"
            defaultValue={logicRule.logic}
            options={RuleLogic.options}
            onBlur={({ value }) => { logicRule.logic = value }}
        />
    )

    renderRule = (rule) => {
        const { ruleGroup } = this.state
        return (
            <div>
                <Select
                    label="Page logic rule"
                    defaultValue={rule.logic}
                    options={Rule.getOptions(rule.questionTypeCode)}
                    onBlur={({ value }) => { rule.logic = value }}
                />
                <div style={{ color: '#8B99A7', marginTop: '25px', fontSize: '12px' }}>{rule.label}</div>
                <div>
                    {rule.options.map((option) => (
                        <div
                            key={option.id}
                            className="wrapper"
                            onClick={() => ruleGroup.removeRule(rule.id, option.id)}
                        >
                            <Badge
                                label={option.label}
                                isRounded
                                icon="fal fa-circle-xmark"
                            />
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    renderRules = () => {
        const { ruleGroup } = this.state
        return ruleGroup.rules.map((rule) => (
            <div
                className={`filter-${rule.ruleType}`}
                key={rule.id ?? rule.logic}
            >
                {rule.ruleType === 'logic' ? this.renderLogic(rule) : this.renderRule(rule)}
            </div>
        ))
    }

    hasRules = () => {
        const { ruleGroup, filterKey } = this.props
        return ruleGroup[filterKey].rules.length > 0
    }

    renderButton = () => {
        const { showBody } = this.state
        const hasRules = this.hasRules()

        const icon = showBody ? 'fa-light fa-chevron-up' : 'fa-light fa-chevron-down'
        const cssClass = hasRules ? 'secondary' : 'primary'
        const label = hasRules ? i18n.t('report.filter.edit') : i18n.t('report.filter.add')

        return (
            <Button
                cssClass={`regular ${cssClass}`}
                label={label}
                onClick={() => this.setState({ showBody: !showBody })}
                icon={icon}
            />
        )
    }

    render() {
        const { showBody } = this.state
        const {
            title, description, optionTitle, optionDescription,
            filterTitle, filterDescription, getFilterOptions,
        } = this.props

        const options = getFilterOptions() || []

        return (
            <Panel cssClass="filter-panel">
                <PanelHeader noDivider>
                    <Applied show={this.hasRules()} />
                    <h4>{title}</h4>
                    <div style={{
                        display: 'flex', alignItems: 'center', flex: 2, justifyContent: 'space-between',
                    }}
                    >
                        <div style={{ flex: 1 }}>
                            {description}
                        </div>
                        {this.renderButton()}
                    </div>
                </PanelHeader>
                {showBody && (
                    <div className="body">
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <Panel style={{ display: 'flex', flex: 2 }}>
                                <div style={{
                                    display: 'flex', gap: '10px', flex: 2, flexDirection: 'column', minHeight: 0,
                                }}
                                >
                                    <h5>{optionTitle}</h5>
                                    <InfoAccordion
                                        title={optionDescription}
                                        hideChevron
                                        cssClass="tertiary"
                                        icon="fa-light fa-circle-exclamation"
                                    />
                                    <div style={{
                                        display: 'flex', flexDirection: 'column', gap: '10px', minHeight: 0, overflow: 'auto',
                                    }}
                                    >
                                        {this.renderQuestionOptions(options)}
                                    </div>
                                </div>
                            </Panel>
                            <Panel style={{
                                display: 'flex', flexDirection: 'column', gap: '10px', flex: 3,
                            }}
                            >
                                <div style={{
                                    display: 'flex', gap: '10px', flex: 2, flexDirection: 'column', minHeight: 0,
                                }}
                                >
                                    <h5>{filterTitle}</h5>
                                    <InfoAccordion
                                        title={filterDescription}
                                        hideChevron
                                        cssClass="tertiary"
                                        icon="fa-light fa-circle-exclamation"
                                    />
                                    <div style={{
                                        display: 'flex', flexDirection: 'column', border: '1px solid #F7F8FA', borderRadius: '6px', minHeight: 0, overflow: 'auto',
                                    }}
                                    >
                                        {this.renderRules()}
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Button
                                        label={i18n.t('discard')}
                                        icon="fa-thin fa-circle-xmark"
                                        cssClass="regular tertiary"
                                        onClick={this.discard}
                                    />
                                    <Button
                                        label={i18n.t('save')}
                                        icon="fa-thin fa-save"
                                        cssClass="regular primary"
                                        onClick={this.save}
                                    />
                                </div>
                            </Panel>
                        </div>
                    </div>
                )}
            </Panel>
        )
    }
}

export default FilterPanel
